export default __webpack_public_path__ + "static/media/mazesolver.24a39c7a.mp4";